import React from "react";

export const LeftArrowIcon = ({
  width = 34.167,
  height = "25.308",
  fill = "#c6c6c6",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34.167 25.308"
      {...{ width, height, fill }}
    >
      <path
        id="Color_Overlay"
        data-name="Color Overlay"
        d="M1277.916,781.369l-11.714-11.68a.972.972,0,0,1-.212-1.061.991.991,0,0,1,.212-.318l11.714-11.679a.975.975,0,1,1,1.38,1.377l-10.048,10.019h29.858a.973.973,0,1,1,0,1.947h-29.858l10.048,10.019a.975.975,0,0,1-1.38,1.377Z"
        transform="translate(-1265.917 -756.346)"
      />
    </svg>
  );
};
